
import heroImg from '../../assets/images/hero-1.png';

export default function Hero() {
  return (
      <section
        id="hero"
        style={{
          position: 'relative',
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          color: 'white',
          overflow: 'hidden',
        }}
      >
        {/* Overlay for better readability */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1,
          }}
        />

        {/* Hero content */}
        <div style={{ zIndex: 2, padding: '1rem' }}>
          <h1
            style={{
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
              fontWeight: 700,
              marginBottom: '1rem',
            }}
          >
            Reviving Classics, Building Beasts
          </h1>
          <p
            style={{
              fontSize: 'clamp(1rem, 2vw, 1.5rem)',
              maxWidth: '600px',
              margin: '0 auto 2rem',
            }}
          >
            Rust Repair, Welding, and Performance Upgrades in Southeast PA.
          </p>
          <a href="#contact">
            <button
              style={{
                backgroundColor: '#e63946',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background 0.3s',
              }}
            >
              Contact Me
            </button>
          </a>
        </div>
      </section>
  );
}
